const getInitials = (name: any) => {
  let initials = '';
  const trimmedName = name ? name.trim() : null;
  if (trimmedName && trimmedName.length > 0) {
    const nameSplit = trimmedName.split(' ');
    const length = nameSplit.length;
    if (length > 0) {
      initials += nameSplit[0][0];

      if (length > 1) {
        initials += nameSplit[length - 1][0];
      }
    }
  }
  return initials;
};

export const SpeakerUtils = {
  getInitials,
};
